import AdminPropertyReviewTable from './AdminPropertyReviewTable';

const DeclinedProperties = () => (
  <AdminPropertyReviewTable
    filterStatus="declined"
    title="العقارات المرفوضة"
    subtitle="إدارة العقارات المرفوضة وإمكانية الموافقة عليها أو إعادتها للمراجعة"
  />
);

export default DeclinedProperties;
